module.exports = __webpack_public_path__ + "img/mortgage-desk-img.48e8e666.webp";